import ReportPage from './ReportPage'
import {LojasRelacionamentoType} from './lojasRelacionamento'

export default function LojasRelacionamentoReport({type}: {type: LojasRelacionamentoType}) {
  return <ReportPage type={type} />
}
